import { useCallback, useEffect, useState } from "react";
import { http } from "../services/http";
import { sortByDueDateDesc } from "../domain/sprints";

// A API já respondeu de duas formas, como em /projects: array cru em data e
// objeto com a lista dentro.
function readSprints(payload) {
  if (Array.isArray(payload?.data)) return payload.data;
  return payload?.data?.sprints || [];
}

export function useSprints(projectId) {
  const [sprints, setSprints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadToken, setReloadToken] = useState(0);

  const reload = useCallback(() => setReloadToken((token) => token + 1), []);

  useEffect(() => {
    const controller = new AbortController();

    setLoading(true);
    setError(null);

    http
      .get("/sprints", { params: { projectId }, signal: controller.signal })
      .then((response) => {
        if (controller.signal.aborted) return;
        setSprints(sortByDueDateDesc(readSprints(response.data)));
        setLoading(false);
      })
      .catch((requestError) => {
        if (controller.signal.aborted) return;

        // O backend devolve 404 com "Nenhuma sprint encontrada": o caso vazio
        // chega como erro, e sem esta tradução um projeto sem sprints veria a
        // tela de falha em vez do estado vazio.
        if (requestError?.response?.status === 404) {
          setSprints([]);
          setLoading(false);
          return;
        }

        setError(requestError);
        setSprints([]);
        setLoading(false);
      });

    return () => controller.abort();
  }, [projectId, reloadToken]);

  return { sprints, loading, error, reload };
}
